var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_55570",
    "data-name": "Group 55570",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.875,
    height: 71.359,
    viewBox: "0 0 63.875 71.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85437",
    "data-name": "Path 85437",
    d: "M129.319,37.055a18.528,18.528,0,1,0-18.527-18.528A18.577,18.577,0,0,0,129.319,37.055Z",
    transform: "translate(-97.377 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85438",
    "data-name": "Path 85438",
    d: "M87.9,261.321a17.274,17.274,0,0,0-1.861-3.4A23.03,23.03,0,0,0,70.1,247.89a3.41,3.41,0,0,0-2.346.566,19.749,19.749,0,0,1-23.3,0,3.036,3.036,0,0,0-2.346-.566,22.863,22.863,0,0,0-15.938,10.032,19.916,19.916,0,0,0-1.861,3.4,1.721,1.721,0,0,0,.081,1.537,32.289,32.289,0,0,0,2.184,3.236A30.748,30.748,0,0,0,30.3,270.3a48.48,48.48,0,0,0,3.722,3.236,36.895,36.895,0,0,0,44.013,0,35.57,35.57,0,0,0,3.722-3.236,37.365,37.365,0,0,0,3.722-4.207,28.378,28.378,0,0,0,2.184-3.236A1.381,1.381,0,0,0,87.9,261.321Z",
    transform: "translate(-24.165 -209.46)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.dc0e97589ef9ed0911e6406394a06d77.svg";
export { ForwardRef as ReactComponent };